/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query'
import apiClient from '@/apiClient'

export type NotificationRow = {
  id: string
  type: string
  channel: string
  status: string
  error?: string | null
  createdAt: string
  sentAt?: string | null
  meta: any
  jobKey?: string | null
}

export const useNotificationsQuery = (
  params: { type?: string; take?: number },
  enabled = true
) =>
  useQuery({
    queryKey: ['notifications', params.type ?? 'ALL', params.take ?? 50],
    enabled,
    queryFn: async () => {
      const { data } = await apiClient.get<{
        ok: boolean
        items: NotificationRow[]
      }>('/notifications', { params })
      return data.items ?? []
    },
  })
